import { useCallback, useLayoutEffect, useMemo, useState } from 'react'

import { useEventListener } from './useEventListener'
import { useResizeObserver } from './useResizeObserver'

type InitialSizes = {
  initialWidth: number
  initialHeight: number
}

const initialSizes: InitialSizes = {
  initialHeight: 0,
  initialWidth: 0,
}

/**
 * Вычисляет размер контейнера при изменении размера окна или соседних элементов
 *
 * @param container элемент, размер которого нужно отслеживать и менять
 * @param initialSize начальные размеры элемента
 * @returns размеры, с учетом изменений соседних элементов и размеров окна
 */
export const useAutoResize = (
  container: HTMLElement | null,
  { initialHeight, initialWidth } = initialSizes,
) => {
  const [width, setWidth] = useState(initialWidth)
  const [height, setHeight] = useState(initialHeight)

  const updateSize = useCallback(() => {
    if (!container) return

    const { width, height } = container.getBoundingClientRect()

    setWidth(Math.floor(width))
    setHeight(Math.floor(height))
  }, [container])

  useResizeObserver(container, updateSize)
  useEventListener('resize', updateSize)
  useLayoutEffect(updateSize, [updateSize])

  const size = useMemo(() => ({ width, height }), [width, height])

  return size
}
